export enum ErrorMessage {
  FieldRequired = "Fill out all required fields before proceeding.",
}

export enum ServerErrorMessage {
  Error = "Error",
}

export enum ServerErrorCode {
  test = "test",
}

export const serverErrorMap = (code: ServerErrorCode): ServerErrorMessage => {
  switch (code) {
    case ServerErrorCode.test:
      return ServerErrorMessage.Error;
    default:
      return ServerErrorMessage.Error;
  }
};

export const getErrorMessage = (fieldName: string, errorMessage: ErrorMessage) => {
  return errorMessage.replace("{fieldName}", fieldName);
};
